import { api } from "../../lib/api";
import { toast } from "sonner";

// Corbeille « Équipement par programme » : articles supprimés → restaurer en 1 clic (ou supprimer définitivement)
export function EquipmentTrash({ items, onChange }) {
  if (!items?.length) return null;
  const restore = async (it) => {
    try { await api.post(`/program-equipment/trash/${it.id}/restore`); toast.success(`« ${it.label} » restauré`); onChange(); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  const purge = async (it) => {
    try { await api.delete(`/program-equipment/trash/${it.id}`); toast.success("Supprimé définitivement"); onChange(); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  return (
    <details className="border border-zinc-800 rounded-lg p-3 bg-zinc-950/40" data-testid="pe-trash">
      <summary className="cursor-pointer text-xs font-bold uppercase tracking-wide text-zinc-400">🗑 Supprimés récemment ({items.length}) — restaurer</summary>
      <div className="mt-2 space-y-1">
        {items.map((it) => (
          <div key={it.id} className="flex flex-wrap items-center gap-2 text-xs rounded px-2 py-1.5 bg-zinc-950/60 opacity-80" data-testid={`pe-trash-${it.id}`}>
            <span className="font-medium text-zinc-100 line-through decoration-rose-400/60">{it.label}</span>
            <span className="text-zinc-500">· {it.program_label} · {it.category}</span>
            <span className="text-zinc-600">· supprimé {(it.deleted_at || "").slice(0, 16).replace("T", " ")}{it.deleted_by ? ` par ${it.deleted_by}` : ""}</span>
            <span className="ml-auto flex items-center gap-1">
              <button onClick={() => restore(it)} className="px-2 py-0.5 rounded bg-emerald-500/20 text-emerald-300 hover:bg-emerald-500/30" data-testid={`pe-restore-${it.id}`}>↩ Restaurer</button>
              <button onClick={() => purge(it)} className="px-1.5 py-0.5 rounded text-zinc-500 hover:text-rose-400 hover:bg-rose-500/10" title="Supprimer définitivement" data-testid={`pe-purge-${it.id}`}>✕</button>
            </span>
          </div>
        ))}
      </div>
    </details>
  );
}
